// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"e7-z"};